/* eslint-disable no-unused-vars */
import React from 'react'
import styled, { css } from 'styled-components'
import CurrencyInput from '@ericblade/react-currency-input'
import { IMaskMixin } from 'react-imask'
import Input from './Input'
import { colors } from '../../styles/colors'

const CurrencyInputBase = styled(CurrencyInput)`
    background-color: #f5f4f4;
    color: #505050;
    font-weight: 400;
    outline: none;
    padding: 13px 0 13px 13px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 300;
    flex: 1 1;
    width: calc(100%);

    border: 1px solid
        ${({ hasError, errorColor }) => {
            if (hasError) {
                if (errorColor) return errorColor
                return '#C6487E'
            }
            return '#e5e7eb'
        }};

    &:focus {
        border-color: ${({ hasError, errorColor }) => {
            if (hasError) {
                if (errorColor) return errorColor
                return '#C6487E'
            }
            return colors.aleloGreen
        }};

        box-shadow: 0 0 2px
            ${({ hasError, errorColor }) => {
                if (hasError) {
                    if (errorColor) return errorColor
                    return '#C6487E'
                }
                return colors.aleloGreen
            }};

        background-color: white;

        ${(p) =>
            p.hasError &&
            css`
                box-shadow: 0 0 2px
                    ${({ errorColor }) => (errorColor ? errorColor : '#C6487E')};
                border: 1px solid
                    ${({ errorColor }) => (errorColor ? errorColor : '#C6487E')};
            `}
    }
`

export const QuantityInputIMask = IMaskMixin(({ inputRef, ...otherProps }) => (
    <Input {...otherProps} ref={inputRef} />
))
export const NumberInput = ({ onChange, children, ...otherProps }) => (
    <QuantityInputIMask onAccept={onChange} {...otherProps} />
)
export const CurrencyValueInput = ({ onChange, children, ...otherProps }) => (
    <CurrencyInputBase
        onChangeEvent={(e, mask, value) => onChange(value)}
        {...otherProps}
    />
)
